import React, { useEffect } from 'react'

import LabeledInput from 'modules/core/components/LabeledInput'
import TextEditor, { type EditorHandle } from 'modules/core/components/TextEditor'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

const Description = () => {
  const { associatedTaskItem: item, form, setInitialFormValue } = useFormProvider()

  const editorRef = React.useRef<EditorHandle>(null)

  useEffect(() => {
    setInitialFormValue({ instruction: item?.instruction })
  }, [])

  return (
    <LabeledInput isLegend label={i18n.t('processes.process_settings.wizard.description.label')}>
      <TextEditor
        ref={editorRef}
        initialEditorState={{ data: form.values.instruction.toString() ?? 'fds' }}
        placeholder={i18n.t('processes.process_settings.tasks.form.instruction_placeholder')}
        height="s200"
        onChange={(e) => {
          form.setValues({ instruction: e })
        }}
        enableBetaFeatures={false}
      />
    </LabeledInput>
  )
}

export default Description
